/**
 * Note on price guidance categories:
 Let's assume priceGuidanceAllStarAvgPrice = X

 minRange = filter min range value i.e. (0)
 maxRange = filter max range value i.e. (500)

 priceGuidanceFilterData
 [0] - (minRange to X * .7%) price come in this category.
 [1] - (X*.7% + 1 to X ) price come in this category.
 [2] - (X+ 1 to X * 1.3% ) price come in this category.
 [3] - (X*1.3% +1 to maxRange) price come in this category

 * @param priceGuidanceFilterData
 * @param min
 * @param max
 * @param thisMin
 * @param thisMax
 * @returns {*}
 */
export function getUpdatedPriceGuidanceFilter({ priceGuidanceFilterData, min, max, thisMin, thisMax }) {
  priceGuidanceFilterData.map((item) => {
    if (item.min >= min && item.max <= max) {
      item.checked = true
    } else {
      item.checked = false
    }
  })

  if (min === thisMin && priceGuidanceFilterData[2].max <= max) {
    priceGuidanceFilterData[1].disabled = true
  } else {
    priceGuidanceFilterData[1].disabled = false
  }
  if (priceGuidanceFilterData[1].min >= min && max === thisMax) {
    priceGuidanceFilterData[2].disabled = true
  } else {
    priceGuidanceFilterData[2].disabled = false
  }

  return priceGuidanceFilterData
}
